// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__8mKjp","cta":"footer_cta__PXjdG","overlay":"footer_overlay__zTZ2c"};